import { useState } from "react";
import BackToHomeBtn from "../../components/BackToHomeBtn";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import emergancyRequest from "../../services/emergancyRequest";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loaderActions } from "../../redux/slices/loadingSlice";
import useCookiesCheck from "../../utils/useCookiesCheck";
import { useTranslation } from "react-i18next";

const UrgentRequest = () => {
  useCookiesCheck();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking);
  const [vorname, setVorname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const { t } = useTranslation();

  const submitHandler = async (e: any) => {
    e.preventDefault();
    dispatch(loaderActions.showLoader());
    const reqBody = {
      bookingNumber: booking.bookingNumber,
      email: email,
      firstName: vorname,
      location: "",
      name: booking.bookingUsername,
      problem: description,
      streetHouseNumber: "",
      telefonnummer: phoneNumber,
      zip: "",
    };

    try {
      const response = await emergancyRequest(reqBody);

      if (response.success) {
        if (response.matching) {
          if (response.vald) {
            if (response.urgentReq) {
              toast.success(t("urgentRequest.message1"));
            } else if (response.neardepartureAndUrgent) {
              toast.success(t("urgentRequest.message2"));
            } else if (response.notUrgent) {
              toast.info(t("urgentRequest.message3"));
            }

            navigate("/booking-details");
          }

          if (!response.vald) {
            toast.info(t("urgentRequest.message4"));
          }
        }

        if (!response.matching) {
          toast.error(t("urgentRequest.message5"));
        }
      }

      if (!response.success) {
        toast.error(t("urgentRequest.message6"));
      }

      dispatch(loaderActions.hideLoader());
    } catch (ex: any) {
      toast.error("send fail");
      dispatch(loaderActions.hideLoader());
    }
  };

  return (
    <div className="bg-light py-2">
      <div className="container">
        <BackToHomeBtn />

        <div className="row justify-content-center">
          <div className="col-12 col-lg-6">
            <form
              className="bg-white p-3 rounded border"
              onSubmit={submitHandler}
            >
              <div className="mb-3">
                <label className="form-label">
                  {t("other.bookingNumber")}*
                </label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  placeholder=""
                  value={booking.bookingNumber}
                  readOnly
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Name*</label>
                <input
                  type="text"
                  className="form-control"
                  value={booking.bookingUsername}
                  disabled
                  readOnly
                />
              </div>

              <div className="mb-3">
                <label className="form-label"> {t("other.firstName")}*</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e: any) => setVorname(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label"> {t("other.telephone")}*</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e: any) => setPhoneNumber(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email*</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e: any) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("other.problemDesc")}*</label>
                <textarea
                  className="form-control"
                  rows={4}
                  onChange={(e: any) => setDescription(e.target.value)}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn btn-warning w-100 text-white"
              >
                {t("other.submitYourRequest")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrgentRequest;
